import React from "react";

import RemindMeLater from "./RemindMeLater";
import MissingWorklogList from "./MissingWorklogList";
import "./missingWorklog.scss";
import FormDialog from "../Dialog/FormDialog";
import { useWorklogMissingDialog } from "./hooks/useWorklogMissingDialog";

function WorklogMissing() {
  const { dailyWorklogHours, dialog, handleClose, list } =
    useWorklogMissingDialog();

  return (
    <>
      {dialog && (
        <FormDialog
          open={dialog}
          title={"Worklog Missing"}
          showCrossIcon={false}
        >
          <MissingWorklogList
            list={list}
            daily_worklog_hours={dailyWorklogHours}
          />
          <RemindMeLater handleClose={handleClose} />
        </FormDialog>
      )}
    </>
  );
}

export default React.memo(WorklogMissing);
